import http from 'plugins/axios';

export default {
  getBannerList(data) {
    return http.post({
      url: '/la/admin/banner/list',
      data,
      dataType: 'form'
    });
  },
  getBannerDetail(id) {
    return http.get({
      url: `/la/admin/banner/detail/${id}`
    });
  },
  createBanner(data) {
    return http.post({
      url: '/la/admin/banner/add',
      data,
      dataType: 'form'
    });
  },
  updateBanner(data) {
    return http.post({
      url: '/la/admin/banner/update',
      data,
      dataType: 'form'
    });
  },
  removeBanner(id) {
    return http.get({
      url: `la/admin/banner/delete/${id}`
    })
  },
  updateSort(data) {
    return http.post({
      url: '/la/admin/banner/sort',
      data,
      dataType: 'form'
    })
  },
  getbannerType(data) {
    return http.get({
      url: '/la/admin/banner/bannerType',
      data
    })
  }
};
